import React from "react";

import { Field, useFormikContext } from "formik";

import { Box } from "styles/globalComponents";

import { UnitsForm } from "Hooks/useSelectUnits/interface";
import { RegionUnits } from "Hooks/useRegions/interface";

import { CheckboxList } from "Components/CheckboxList";
import { CustomCheckbox } from "Components/Form/CustomCheckbox";
import { ErrorMessage } from "Components/ErrorMessage";
import { LoadingText } from "Components/LoadingText";

import { CheckboxSublist } from "Pages/Product/ProductForm/SectionsForm/Restriction/styles";

import { UnitsSubListCheckbox } from "./UnitsSubListCheckbox";

type UnitsPickerValues = {
  units: UnitsForm;
};

export type UnitsRegionPickerProps = {
  regions: RegionUnits[] | undefined;
  loadingRegions: boolean;
  regionsError: string | null;
  onSelectAllUnits: () => void;
  onSelectRegion: (regionId: number) => void;
  onSelectUnit: (unitId: number) => void;
  readOnly?: boolean;
};

export const UnitsRegionPicker = ({
  regions,
  loadingRegions,
  regionsError,
  onSelectAllUnits,
  onSelectRegion,
  onSelectUnit,
  readOnly = false,
}: UnitsRegionPickerProps) => {
  const { values } = useFormikContext<UnitsPickerValues>();
  const highestUnitBlock =
    regions
      ?.map((region) => region?.units?.length)
      .filter(Boolean)
      .sort((a, b) => a - b)
      .at(-1) ?? 0;

  return (
    <>
      {loadingRegions && !regionsError && (
        <LoadingText text="Carregando lista de unidades" />
      )}

      {regionsError && (
        <ErrorMessage text="Ocorreu um erro ao buscar a lista de unidades" />
      )}

      {!loadingRegions && !regionsError && (
        <CheckboxList title="Unidades*" error="">
          <Box mt="15">
            <Field
              component={CustomCheckbox}
              type="checkbox"
              label="Todas unidades"
              name="units"
              disabled={readOnly}
              onChange={readOnly ? () => {} : onSelectAllUnits}
              checked={values.units.include.includes(0)}
            />
            <CheckboxSublist
              className="checkbox-units"
              height={highestUnitBlock * 31}
            >
              {regions?.map((region) => (
                <UnitsSubListCheckbox
                  key={region.id}
                  region={region}
                  handleSelectAllRegionUnits={onSelectRegion}
                  handleSelectUnits={onSelectUnit}
                  readOnly={readOnly}
                />
              ))}
            </CheckboxSublist>
          </Box>
        </CheckboxList>
      )}
    </>
  );
};
